import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://592245f8f6c7a507e961850e33bf4ac0@o4511349225095168.ingest.us.sentry.io/4511349226799104',
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/ch-varun\.xyz/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
  environment: import.meta.env.MODE,
})
